import { requests } from '../config'
import { IImageObjectRef, IImageUploadPayload } from './models/imageObject'
import { IImageUploadResult } from './models/imageUploadResult'

const buildPath = (ref: IImageObjectRef): string =>
  `images/${ref.ObjectType}/${ref.ObjectID}/${ref.ObjectSubID}`

export const Images = {
  // Content-Type is left to axios so the multipart boundary is generated
  // correctly — same as Warehouse.uploadLocationsFile.
  uploadImages: (
    ref: IImageObjectRef,
    payload: IImageUploadPayload,
  ): Promise<IImageUploadResult> => {
    const formData = new FormData()
    // One part per image, all under the same field name.
    payload.files.forEach((file) => formData.append('file', file))
    // Sent even when empty: the server skips storing a blank comment.
    formData.append('Comment', payload.comment)
    return requests.post(buildPath(ref), 'go', formData)
  },
  /** Заведён на будущее: в UI пока не интегрирован. */
  getImages: (ref: IImageObjectRef): Promise<IImageUploadResult> =>
    requests.get(buildPath(ref), 'go'),
}
